import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { DataLine, H2 } from "commons";

export function ClientAccountDetails({ clientId, fsaCategory }) {
    const cssClass = clientId || fsaCategory ? null : "large-only";

    return (
        <div className={cssClass} data-testid="client-account-details">
            <H2 secondary textAlign="center">
                Account
            </H2>
            <Fields>
                <DataLine
                    name="Client reference"
                    value={clientId ? clientId.toString() : undefined}
                />
                <DataLine name="Client category" value={fsaCategory} />
            </Fields>
        </div>
    );
}

const Fields = styled.div`
    background: ${props => props.theme.tertiary};
    padding: 1.5em;
`;

ClientAccountDetails.propTypes = {
    clientId: PropTypes.number,
    fsaCategory: PropTypes.string
};
